import { MessageSquare } from 'lucide-react';
import React from 'react';
import PropTypes from 'prop-types';
import { CommentDisplayPropType } from '../../../types/propTypes';
import { parseSlashDateAsLocal } from '../../../utils/dateUtils';

const CommentsSection = ({ comments }) => {
  if (!comments?.length) {
    return (
      <div className="bg-gray-50 p-4 rounded-lg">
        <div className="flex items-center gap-2 text-gray-500">
          <MessageSquare className="w-4 h-4" />
          <p className="text-sm">No comments yet</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 p-4 rounded-lg space-y-4">
      {comments.map((comment, index) => (
        <div
          key={index}
          className="bg-white rounded-lg p-4 border border-gray-100 space-y-2"
        >
          <div className="flex justify-between items-start">
            <div>
              <h4 className="font-medium text-gray-900">{comment.userName}</h4>
              <p className="text-sm text-gray-500">{comment.userFunction}</p>
            </div>
            <time className="text-sm text-gray-400">
              {parseSlashDateAsLocal(comment.date)?.toLocaleDateString()}
            </time>
          </div>
          <p className="text-gray-600 text-sm leading-relaxed">
            {comment.text}
          </p>
        </div>
      ))}
    </div>
  );
};

CommentsSection.propTypes = {
  comments: PropTypes.arrayOf(CommentDisplayPropType)
};

export default CommentsSection;
